import React, { useEffect } from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import { NormalizeStyles } from "./normalize";
import { GlobalStyles } from "./global-styles";
import rtlcss from "./stylis/rtlcss";
import { PageMetadataProvider, Direction, Environment } from "../context/PageMetadata";
import { ActionContextProvider } from "../context/ActionProvider";
const mapEnvironment = (env) => {
    switch (env) {
        case "test":
            return Environment.test;
        case "preview":
            return Environment.preview;
        case "live":
        default:
            return Environment.live;
    }
};
export const SkinProvider = ({ skin, children, dir = Direction.LTR, locale = "en-us", environment = "live", globalStyles = true, }) => {
    useEffect(() => {
        const triggerTextResize = () => {
            window.dispatchEvent(new CustomEvent("resize"));
        };
        if (document?.fonts) {
            document.fonts.onloadingdone = triggerTextResize;
        }
    }, []);
    return (React.createElement(StyleSheetManager, { stylisPlugins: dir === Direction.RTL ? [rtlcss] : [] },
        React.createElement(PageMetadataProvider, { locale: locale, dir: dir, environment: mapEnvironment(environment) },
            React.createElement(HelmetProvider, null,
                React.createElement(Helmet, null,
                    React.createElement("html", { lang: locale, dir: dir }),
                    skin.cssImports?.map((href) => React.createElement("link", { key: href, rel: "stylesheet", href: href }))),
                React.createElement(ThemeProvider, { theme: { skin } },
                    React.createElement(NormalizeStyles, null),
                    globalStyles && React.createElement(GlobalStyles, null),
                    React.createElement(ActionContextProvider, null, children))))));
};
//# sourceMappingURL=SkinProvider.js.map